<template>
  <div class="root" :class="{ disable: !selected }" @click="onCkick">
    <svg
      v-if="text === '観光'"
      id="グループ_2096"
      data-name="グループ 2096"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="43.3"
      height="35.256"
      viewBox="0 0 43.3 35.256"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="長方形_1377"
            data-name="長方形 1377"
            width="43.3"
            height="35.256"
          />
        </clipPath>
      </defs>
      <g
        id="グループ_2095"
        data-name="グループ 2095"
        transform="translate(0 0)"
        clip-path="url(#clip-path)"
      >
        <path
          id="パス_9435"
          data-name="パス 9435"
          d="M28.635,20.55a6.982,6.982,0,1,1-6.985-6.985,6.993,6.993,0,0,1,6.985,6.985M43.3,10.631V30.469a4.786,4.786,0,0,1-4.788,4.787H4.787A4.789,4.789,0,0,1,0,30.469V10.631A4.789,4.789,0,0,1,4.787,5.845h5.892V4.19A4.191,4.191,0,0,1,14.87,0H28.436a4.191,4.191,0,0,1,4.191,4.19V5.845h5.885A4.786,4.786,0,0,1,43.3,10.631M32.223,20.55A10.574,10.574,0,1,0,21.65,31.123,10.581,10.581,0,0,0,32.223,20.55"
          transform="translate(0 0)"
        />
        <path
          id="パス_9435_-_アウトライン"
          data-name="パス 9435 - アウトライン"
          d="M38.512,35.756H4.787A5.293,5.293,0,0,1-.5,30.469V10.631A5.293,5.293,0,0,1,4.787,5.345h5.392V4.19A4.7,4.7,0,0,1,14.87-.5H28.436a4.7,4.7,0,0,1,4.691,4.69V5.345h5.385A5.293,5.293,0,0,1,43.8,10.631V30.469A5.293,5.293,0,0,1,38.512,35.756ZM4.787,6.345A4.291,4.291,0,0,0,.5,10.631V30.469a4.291,4.291,0,0,0,4.287,4.287H38.512A4.292,4.292,0,0,0,42.8,30.469V10.631a4.292,4.292,0,0,0-4.288-4.287H32.127V4.19A3.7,3.7,0,0,0,28.436.5H14.87a3.7,3.7,0,0,0-3.691,3.69V6.345ZM21.65,31.623A11.073,11.073,0,1,1,32.723,20.55,11.086,11.086,0,0,1,21.65,31.623Zm0-21.146A10.073,10.073,0,1,0,31.723,20.55,10.085,10.085,0,0,0,21.65,10.477Zm0,17.558a7.485,7.485,0,1,1,7.485-7.485A7.49,7.49,0,0,1,21.65,28.035Zm0-13.969a6.485,6.485,0,1,0,6.485,6.485A6.489,6.489,0,0,0,21.65,14.065Z"
          transform="translate(0 0)"
        />
      </g>
    </svg>
    <svg
      v-if="text === '食事'"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="25"
      height="38"
      viewBox="0 0 25 38"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="長方形_1380"
            data-name="長方形 1380"
            width="25"
            height="38"
            transform="translate(0 0.382)"
          />
        </clipPath>
      </defs>
      <g
        id="グループ_2285"
        data-name="グループ 2285"
        transform="translate(0 -0.382)"
      >
        <g
          id="グループ_2109"
          data-name="グループ 2109"
          clip-path="url(#clip-path)"
        >
          <path
            id="パス_9456"
            data-name="パス 9456"
            d="M11.155.681A.8.8,0,0,0,10.361,0h-.027a.8.8,0,0,0-.773.732l-.7,8.4c-.043.518-.968.518-1.011,0l-.7-8.4a.8.8,0,0,0-1.6,0l-.7,8.4c-.043.518-.968.518-1.011,0l-.7-8.4A.8.8,0,0,0,2.35,0H2.324A.8.8,0,0,0,1.53.681L.072,10.353A6.247,6.247,0,0,0,3.8,17.029l-1.241,17.3a3.783,3.783,0,0,0,3.784,4.041h.006a3.817,3.817,0,0,0,2.778-1.2,3.775,3.775,0,0,0,1.008-2.839L8.89,17.029a6.247,6.247,0,0,0,3.725-6.676Z"
            transform="translate(-0.001)"
          />
          <path
            id="パス_9457"
            data-name="パス 9457"
            d="M230.529.163a.81.81,0,0,0-.731-.1,11.116,11.116,0,0,0-6.965,10.345c0,5.616,1.837,8.452,2.871,9.6l-1.029,1.023a.792.792,0,0,0-.231.486l-1.272,12.647a3.825,3.825,0,0,0,.976,2.956,3.865,3.865,0,0,0,6.721-2.575V.815a.79.79,0,0,0-.339-.652"
            transform="translate(-206.041 -0.016)"
          />
        </g>
      </g>
    </svg>
    <svg
      v-if="text === 'お土産'"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="38"
      viewBox="0 0 32 38"
    >
      <path
        id="icon03"
        d="M364.962,318.368a.294.294,0,0,0-.29-.274h-5.236v-1.484a8.438,8.438,0,1,0-16.873,0v1.484h-5.236a.294.294,0,0,0-.29.274L335,345.681a.3.3,0,0,0,.077.224.286.286,0,0,0,.213.1h31.418a.287.287,0,0,0,.213-.1.3.3,0,0,0,.077-.224Zm-20.072-1.759a6.11,6.11,0,1,1,12.218,0v1.484H344.89Zm-1.164,9.8a2.942,2.942,0,0,1-2.909-2.969,2.806,2.806,0,0,1,1.745-2.721v2.721a1.164,1.164,0,1,0,2.327,0v-2.719a2.812,2.812,0,0,1,1.745,2.719,2.942,2.942,0,0,1-2.909,2.969Zm14.545,0a2.942,2.942,0,0,1-2.909-2.969,2.806,2.806,0,0,1,1.745-2.721v2.721a1.164,1.164,0,1,0,2.327,0v-2.719a2.812,2.812,0,0,1,1.745,2.719,2.942,2.942,0,0,1-2.909,2.969Zm0,0"
        transform="translate(-334.999 -308)"
      />
    </svg>
    <svg
      v-if="text === '体験'"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="44"
      height="38"
      viewBox="0 0 44 38"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="長方形_1400"
            data-name="長方形 1400"
            width="44"
            height="38"
            transform="translate(0 0.077)"
          />
        </clipPath>
      </defs>
      <g
        id="グループ_2336"
        data-name="グループ 2336"
        transform="translate(0 -0.077)"
      >
        <g
          id="グループ_2333"
          data-name="グループ 2333"
          clip-path="url(#clip-path)"
        >
          <path
            id="パス_9519"
            data-name="パス 9519"
            d="M42.688,35.78h-3.8L23.935,8.376l2.749-5.041a1.581,1.581,0,0,0-2.776-1.514L22.135,5.073,20.361,1.821a1.581,1.581,0,0,0-2.776,1.514l2.749,5.041L5.385,35.78h-3.8a1.581,1.581,0,0,0,0,3.162H42.688a1.581,1.581,0,1,0,0-3.162m-15.81,0H17.392V29.456a4.743,4.743,0,0,1,9.486,0Z"
            transform="translate(0 -0.865)"
          />
        </g>
      </g>
    </svg>

    <svg
      v-if="text === '温泉'"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="39"
      height="35"
      viewBox="0 0 39 35"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="長方形_1397"
            data-name="長方形 1397"
            width="39"
            height="35"
          />
        </clipPath>
      </defs>
      <g
        id="グループ_2294"
        data-name="グループ 2294"
        transform="translate(0 0)"
      >
        <g
          id="グループ_2279"
          data-name="グループ 2279"
          transform="translate(0 0)"
          clip-path="url(#clip-path)"
        >
          <path
            id="パス_9512"
            data-name="パス 9512"
            d="M35.676,13.495c.094.076.239.192.42.361a8.859,8.859,0,0,1,1.376,1.614,8.962,8.962,0,0,1,.754,1.378,8.435,8.435,0,0,1,.3.79H38.6l.068.509.126.458a8.472,8.472,0,0,1,.167,1.136l.035.54c.006.155,0,.29,0,.428l0,.164a10.323,10.323,0,0,1-.382,2.493,12.3,12.3,0,0,1-1.027,2.494,13.705,13.705,0,0,1-1.628,2.329,17.363,17.363,0,0,1-4.587,3.738,22.159,22.159,0,0,1-5.705,2.251,24.433,24.433,0,0,1-3.057.554c-.571.06-1.065.115-1.562.136-.252.016-.515.03-.778.032l-.821.017L18.4,34.891l-.414-.023c-.538-.021-1.048-.077-1.553-.132a24.844,24.844,0,0,1-3.094-.555,22.191,22.191,0,0,1-5.7-2.247,17.341,17.341,0,0,1-4.594-3.74,14.11,14.11,0,0,1-1.629-2.328,12.457,12.457,0,0,1-1.028-2.5,10.023,10.023,0,0,1-.189-4.7l.2-.8.01-.01.047-.142a7.183,7.183,0,0,1,.333-.879,8.583,8.583,0,0,1,.755-1.374,8.938,8.938,0,0,1,1.377-1.608c.182-.166.326-.284.425-.363L5.2,11.982,4.36,14.057c0,.006-.09.222-.228.613a11.053,11.053,0,0,0-.448,1.693,8.239,8.239,0,0,0-.122,1.158c-.008.219,0,.424.008.635v.025l.017.018,0,.209.052.436a7.074,7.074,0,0,0,.995,2.726A9.37,9.37,0,0,0,6.967,24.1a15.252,15.252,0,0,0,3.521,1.986,21.924,21.924,0,0,0,4.306,1.225c.765.147,1.54.231,2.333.309.386.03.78.057,1.145.072l.294.016,1,.015.542-.008c.212,0,.4-.009.586-.019.407-.016.8-.041,1.2-.074.747-.074,1.548-.158,2.319-.3a22.038,22.038,0,0,0,4.319-1.226,15.243,15.243,0,0,0,3.514-1.981,9.413,9.413,0,0,0,2.34-2.531,7.041,7.041,0,0,0,.659-1.381s.093-.262.114-.332l.094-.357a1.59,1.59,0,0,0,.044-.2s.045-.219.06-.278a.563.563,0,0,0,.022-.118l.049-.541-.006-.169,0-.045.022-.025c.006-.2.011-.408,0-.611a8.75,8.75,0,0,0-.124-1.17,10.8,10.8,0,0,0-.449-1.689c-.135-.383-.223-.6-.226-.606L34.2,12.953l-.366-.939Z"
            transform="translate(0 0.084)"
          />
          <path
            id="パス_9513"
            data-name="パス 9513"
            d="M20.954,1.032c-1.127,3.132-1.193,5.158-.2,6.372l.414.5c.385.464.805.97,1.2,1.507A4.423,4.423,0,0,1,23.495,12.2c.091,1.684-1.236,3.936-3.943,6.7a.86.86,0,0,1-.623.26.892.892,0,0,1-.729-.368.718.718,0,0,1-.08-.661c1.13-3.135,1.2-5.162.206-6.377l-.41-.5c-.4-.477-.814-.981-1.2-1.512A4.418,4.418,0,0,1,15.58,6.959c-.091-1.683,1.236-3.935,3.943-6.7A.857.857,0,0,1,20.146,0a.889.889,0,0,1,.729.368.717.717,0,0,1,.079.665"
            transform="translate(-0.038 0)"
          />
          <path
            id="パス_9514"
            data-name="パス 9514"
            d="M11.553,6c-.931,2.582-.991,4.242-.191,5.225l.341.414c.324.39.676.814,1.008,1.263a3.789,3.789,0,0,1,.962,2.376c.077,1.43-1.038,3.332-3.315,5.654a.819.819,0,0,1-.587.246.838.838,0,0,1-.687-.349l-.17-.247.092-.39c.929-2.579.99-4.239.188-5.22l-.343-.418c-.337-.407-.681-.822-1-1.259a3.786,3.786,0,0,1-.962-2.377C6.807,9.49,7.922,7.587,10.2,5.266a.819.819,0,0,1,.587-.246.842.842,0,0,1,.685.345l.172.247Z"
            transform="translate(-0.017 0.035)"
          />
          <path
            id="パス_9515"
            data-name="パス 9515"
            d="M30.077,6.006c-.929,2.577-.989,4.238-.188,5.22l.341.414c.315.379.671.809,1.007,1.263a3.772,3.772,0,0,1,.961,2.375c.078,1.431-1.037,3.334-3.313,5.655a.821.821,0,0,1-.588.246.846.846,0,0,1-.683-.342l-.176-.249.095-.395c.928-2.579.989-4.238.188-5.221l-.346-.419c-.354-.428-.688-.832-1-1.259a3.778,3.778,0,0,1-.961-2.375c-.077-1.43,1.037-3.332,3.314-5.653a.819.819,0,0,1,.587-.246A.84.84,0,0,1,30,5.365l.175.25Z"
            transform="translate(-0.062 0.035)"
          />
        </g>
      </g>
    </svg>
    <div class="text center">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: "image-vartical",
  props: {
    text: { type: String },
    selected: { type: Boolean },
  },
  methods: {
    onCkick() {
      this.$emit("click-image", this.text);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
svg {
  height: 1rem;
  width: 1rem;
  margin-right: 0.5rem;
}
.text {
  font-size: 0.75rem;
  white-space: nowrap;
}
.root {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0.25rem;
  display: flex;
  align-items: center;
  background: white;
  color: #5cd5d6;
  border: #5cd5d6 solid 1px;
  fill: #5cd5d6;
  border-radius: 4px;
  &:first-child {
    margin-left: 1px;
  }
  &:last-child {
    margin-right: 1px;
  }
}
.disable {
  color: #636363;
  fill: #636363;
  border: white solid 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/DropSpotSelect/SpotExampleBarTip.vue